import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { MatomoControlService, MediaControlService, ModalControlService } from '@medsurf/flat-services';
import { AlertControlFacade, SearchControlFacade } from "@medsurf/flat-facades";
import { ZodSharedValidator } from '@medsurf/flat-validators';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'medsurf-modal',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {

  @ViewChild('searchInput', {static: false}) public searchElement: ElementRef<HTMLInputElement>;

  public showModal = false;
  public minLength = 2;
  public isSubmitted = false;
  public page = 1;

  public searchForm = new FormGroup({
    searchString: new FormControl(''),
    typeFilter: new FormControl<FlatModels.PageEntityModels.PageType[]>([]),
    rows: new FormControl(50),
    first: new FormControl(0)
  })

  public typeFilterOptions: { value: FlatModels.PageEntityModels.PageType[], label: string}[] = [
    { value: [], label: 'all' },
    { value: ['Slide', 'Training'], label: 'slides' },
    { value: ['Folder', 'Grid', 'Vocabulary'], label: 'chapters' },
  ]

  public selectedFilterOption = this.typeFilterOptions[0];

  public constructor(public cd: ChangeDetectorRef,
                     public alertControlFacade: AlertControlFacade,
                     public searchControlFacade: SearchControlFacade,
                     public modalControlService: ModalControlService,
                     public matomoControlService: MatomoControlService,
                     public mediaControlService: MediaControlService) {
  }

  /**
   * Ng On Init
   */
  ngOnInit() {
    this.modalControlService.onOpenModal.subscribe(() => {
      this.showModal = this.modalControlService.showModal;
      this.cd.detectChanges();
      if (this.showModal) {
        this.searchElement.nativeElement.focus();
      }
    });
  }

  onSubmit(withLoadingIndicator = true) {
    if (this.searchForm.value.searchString.length < this.minLength) {
      return;
    }
    if (withLoadingIndicator) {
      this.isSubmitted = true;
      this.cd.detectChanges();
    }
    this.searchControlFacade.requestFindNodes(this.searchForm.value).subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.searchForm);
        this.isSubmitted = false;
        this.cd.detectChanges();
      },
      next: () => {
        this.isSubmitted = false;
        this.cd.detectChanges();
        // this.matomoControlService.trackSearch(this.searchForm.value.searchString, nodeSearchResult.total);
      }
    });
  }

  onPageChange(page: number) {
    this.searchForm.controls.first.setValue((page - 1) * this.searchForm.value.rows);
    this.onSubmit();
  }

  setTypeFilter(type: typeof this.selectedFilterOption) {
    this.searchForm.controls.typeFilter.setValue(type.value);
    this.selectedFilterOption = type;
    this.cd.detectChanges();
    this.onSubmit();
  }

  @HostListener('window:keydown', ['$event'])
  private handleKeysModal(event: KeyboardEvent): void {
    if ('Escape' === event.key) {
      this.modalControlService.closeModal();
    }
  }
}
